import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const categoryEndpoints = {
  all: '/admin/categories/all',
  list: (params: TAdminListParams) =>
    `/admin/categories?${buildAdminListQuery(params)}`, // GET
  detail: (id: string) => `/admin/categories/${id}`, // GET
  create: '/admin/categories', // POST
  edit: (id: string) => `/admin/categories/${id}`, // PATCH
  visibility: (id: string) => `/admin/categories/${id}/visibility`, // PATCH
  delete: (id: string, deleteQuestions: boolean) =>
    `/admin/categories/${id}?delete_questions=${deleteQuestions}`, // DELETE
}

export const categoryBackendErrors = {
  CATEGORY_NOT_FOUND: 'Kategori bulunamadı!',
  CATEGORY_EXISTS: 'Bu kategori zaten mevcut!',
  CATEGORY_CREATE: 'Kategori oluşturulurken hata oluştu!',
  CATEGORY_EDIT: 'Kategori düzenlenirken hata oluştu!',
  CATEGORY_DELETE: 'Kategori silinirken hata oluştu!',
  CATEGORY_SYSTEM_CATEGORY_LOCKED:
    'Sistem kategorileri silinemez veya yeniden adlandırılamaz!',
  CATEGORY_PARENT_NOT_FOUND: 'Seçilen üst kategori bulunamadı!',
  CATEGORY_DEPTH: 'Bir alt kategorinin altına yeniden alt kategori eklenemez!',
  CATEGORY_HAS_SUBCATEGORIES:
    'Bu kategorinin alt kategorileri var, önce onları silin!',
  GENERAL_ERROR: 'Beklenemeyen bir hata oluştu!',
}

export const categorySuccessMessages = {
  categoryCreate: 'Kategori başarıyla oluşturuldu!',
  categoryEdit: 'Kategori başarıyla düzenlendi!',
  categoryDelete: 'Kategori başarıyla silindi!',
  categoryVisibility: 'Kategori görünürlüğü güncellendi!',
}
